import jsPDF from 'jspdf';
import 'jspdf-autotable';

const STATUS_LABELS = { voldaan: 'Voldaan', in_behandeling: 'In behandeling', niet_voldaan: 'Niet voldaan' };
const STATUS_COLORS = { voldaan: [34, 197, 94], in_behandeling: [245, 158, 11], niet_voldaan: [239, 68, 68] };

export const generateCompliancePDF = (reportData) => {
  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;

  const org = reportData.organization || {};

  (reportData.frameworks || []).forEach((fw, fwIdx) => {
    if (fwIdx > 0) doc.addPage();
    let y = 25;

    // Header
    doc.setFillColor(0, 0, 0);
    doc.rect(0, 0, pageWidth, 40, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text(`Compliance Rapport: ${fw.framework_name}`, margin, 20);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`${org.name || ''} — ${new Date(reportData.generated_at).toLocaleDateString('nl-NL')}`, margin, 32);
    doc.text(`Score: ${fw.score}% (${fw.met}/${fw.total})`, pageWidth - margin, 32, { align: 'right' });

    y = 50;
    doc.setTextColor(0, 0, 0);

    // Summary box
    doc.setFillColor(245, 245, 245);
    doc.roundedRect(margin, y, pageWidth - 2 * margin, 20, 3, 3, 'F');
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(`${fw.framework_name} ${fw.framework_version ? `v${fw.framework_version}` : ''}`, margin + 5, y + 8);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text(`${fw.description || ''}`, margin + 5, y + 15);
    y += 28;

    // Score bar
    const barWidth = pageWidth - 2 * margin;
    doc.setFillColor(229, 229, 229);
    doc.roundedRect(margin, y, barWidth, 6, 2, 2, 'F');
    const fillColor = fw.score >= 95 ? [34, 197, 94] : fw.score >= 80 ? [245, 158, 11] : [239, 68, 68];
    doc.setFillColor(...fillColor);
    doc.roundedRect(margin, y, barWidth * (fw.score / 100), 6, 2, 2, 'F');
    y += 14;

    // Controls table
    const rows = fw.controls.map(ctrl => [
      ctrl.code,
      ctrl.name,
      ctrl.category || '—',
      STATUS_LABELS[ctrl.status] || ctrl.status,
      ctrl.measure_name || '—',
    ]);

    doc.autoTable({
      startY: y,
      head: [['Code', 'Control', 'Categorie', 'Status', 'Maatregel']],
      body: rows,
      margin: { left: margin, right: margin },
      styles: { fontSize: 8, cellPadding: 2.5 },
      headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
      alternateRowStyles: { fillColor: [250, 250, 250] },
      columnStyles: { 0: { cellWidth: 22 }, 3: { cellWidth: 28 }, 4: { cellWidth: 40 } },
      didParseCell: (data) => {
        if (data.column.index === 3 && data.section === 'body') {
          const status = fw.controls[data.row.index]?.status;
          if (status && STATUS_COLORS[status]) {
            data.cell.styles.textColor = STATUS_COLORS[status];
            data.cell.styles.fontStyle = 'bold';
          }
        }
      },
    });
  });

  // Footer on all pages
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(`Spooker Compliance Rapport — ${org.name || ''} — Pagina ${i}/${pageCount}`, pageWidth / 2, doc.internal.pageSize.getHeight() - 10, { align: 'center' });
  }

  const fwNames = (reportData.frameworks || []).map(f => f.framework_name).join('_');
  doc.save(`Spooker_Compliance_${(org.name || 'Org').replace(/\s+/g, '_')}_${fwNames}_${new Date().toISOString().slice(0, 10)}.pdf`);
};
